import React from "react";
import { Styles } from "./styles";
import { t } from "i18next";
import { useSelector } from "react-redux";
import Pulse from "react-reveal/Pulse";
import { Link } from "react-router-dom";

const HeaderFloatingCardAfterLogin = ({
  coursesCount,
  activitiesCount,
  pointsCount,
}) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  return (
    <Styles>
      <div className="floating-card">
        <Pulse>
          <div className="item">
            <Link className="name" to="/profile/courses">
              {Resource?.my_courses
                ? Resource?.my_courses
                : t("navbar.my_courses")}
            </Link>
            <div className="count">{coursesCount}</div>
          </div>
        </Pulse>
        <Pulse>
          <div className="item">
            <Link className="name" to="/activities">
              {Resource?.activities
                ? Resource?.activities
                : t("navbar.activities")}
            </Link>
            <div className="count">{activitiesCount}</div>
          </div>
        </Pulse>
        <Pulse>
          <div className="item">
            <div className="name">
              {Resource?.points ? Resource?.points : t("profile.points")}
            </div>
            <div className="count">{pointsCount}</div>
          </div>
        </Pulse>
      </div>
    </Styles>
  );
};

export default HeaderFloatingCardAfterLogin;
